<template>
  <SelectSearch
    v-model="localValue"
    @search="search"
    :options="airportOptions"
    placeholderKey="display_code"
    :placeholder="props.placeholder"
    :placement="props.placement"
    v-slot="{ option, selected }"
  >
    <SelectListItemWithSecondaryText
      :option="option"
      :selected="selected"
      primaryKey="display_code"
      secondaryKey="name"
    />
  </SelectSearch>
</template>

<script setup>
import SelectSearch from '@/Common/Forms/SelectMenus/SelectSearch.vue'
import { computed, ref } from 'vue'
import SelectListItemWithSecondaryText from '@/Common/Forms/SelectMenus/SelectListItemWithSecondaryText.vue'
import axios from 'axios'
import { Inertia } from '@inertiajs/inertia'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    required: true,
  },
  placeholder: String,
  placement: String,
})

const localValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)

    if (!value.time_zone_id || !value.time_zone_name) getTimezone(value)
  },
})

const airportOptions = ref([])

let search = _.debounce(function (query) {
  axios
    .get(route('airports.search'), {
      params: { query: query },
    })
    .then((response) => {
      airportOptions.value = response.data
    })
    .catch(() => Inertia.reload())
}, 350)

function getTimezone(airport) {
  axios.get(route('airports.timezone', airport)).then((response) => {
    localValue.value = response.data
  })
}
</script>
